<template>
  <section :class="['inputs_wrap',className]">
    <div v-for="(item,index) in inputItems" :key="index">

      <span>{{item.title}}</span>

      <input
      @click="item.select?goSiteList(item,index):null"
      v-model="inputItem[index]"
      :class="[item.className]"
      :placeholder="item.placeholder"
      :disabled="item.disabled"
      >

      <!-- v-model="item.val" -->
    </div>
  </section>
</template>

<script>
  export default {
    name:"input-info",
    props:{
      className:{
        type:String,
        default:"",
        required:false,
      },
      inputItems:{
        type:Array,
        default: () => [],
        required:true,
      },
    },
    data(){
      return {
        inputItem:[],
      }
    },
    methods:{
      // goSiteList(item,index){
      //   // console.log(item.id,index);
      //    this.$router.push({
      //      name:'MyAddressManager',
      //      params:{
      //         mode:'choose',
      //      }
      //    })
      // },

    },
  }
</script>

<style scoped lang="less">

  @import '../../style/variable';

  .inputs_wrap{
    &>div{
      // margin-top: 10px;
      .flex_wrap(flex-start);
      &>span{
        padding-right: 8px;
        border-right: 1px solid #888;
        text-align: right;
        .flex_items(22%,0,0);
      }
      &>input{
        padding-left: 8px;
        line-height: .8rem;
        border: none;
      }
      &>input:disabled{
        background-color: transparent;
      }
    }
  }

  .member-info{
    .radius();
    .border();
    &>div{
      // border: 1px solid #888;
      .input-padding(.2rem,3%);
    }
    &>div:nth-last-child(n+2){
      border-bottom: 1px solid #888;
    }
  }

  .public-order-input{
    width: 90%;
    margin: 0 auto;
  }


</style>



// WEBPACK FOOTER //
// src/components/child-components/InputInfo.vue